module.exports = __webpack_public_path__ + "img/chuyu_bg.61c4cac9.png";